import {
  GET_PLAYERS,
  GET_PLAYERS_SUCCESS,
  GET_PLAYERS_FAILURE,
  GET_PLAYERS_LOCATIONS,
  GET_PLAYERS_LOCATIONS_SUCCESS,
  GET_PLAYERS_LOCATIONS_FAILURE,
  GET_PLAYER_INFO,
  GET_PLAYER_INFO_SUCCESS,
  GET_PLAYER_INFO_FAILURE,
  GET_PLAYER_TRANSACTIONS,
  GET_PLAYER_TRANSACTIONS_SUCCESS,
  GET_PLAYER_REFERRAL_REWARDS,
  GET_PLAYER_REFERRAL_REWARDS_SUCCESS,
  GET_PLAYER_FIRST_TASK_REWARDS,
  GET_PLAYER_FIRST_TASK_REWARDS_SUCCESS,
  GET_PLAYER_WALLET_TRANSACTIONS,
  GET_PLAYER_WALLET_TRANSACTIONS_SUCCESS,
  GET_PLAYER_MEMBERSHIP_LIST,
  GET_PLAYER_MEMBERSHIP_LIST_SUCCESS,
  GET_PLAYER_ACTIVITY,
  GET_PLAYER_ACTIVITY_SUCCESS,
  GET_LEVEL_CHANGE,
  GET_LEVEL_CHANGE_SUCCESS,
  CHANGE_PLAYERS_FILTERS,
  API_ERROR,
  GET_PLAYERS_LIST,
  GET_PLAYERS_LIST_SUCCESS,
  GET_PLAYER_ENTRIES,
  GET_PLAYER_ENTRIES_SUCCESS,
  GET_PLAYER_HISTORY_ENTRIES,
  GET_PLAYER_HISTORY_ENTRIES_SUCCESS,
  RESET_PLAYER_PROFILE_DATA,
} from "./actionTypes"

const initialState = {
  error: "",
  players: [],
  searchLoading: false,
  searchError: null,
  playersLocations: [],
  playersLocationsLoading: false,
  playersList: [],
  playerInfo: {},
  profileError: null,
  profileLoading: false,
  playerTransactions: {},
  playerWalletTransactions: {},
  referralRewards: {},
  firstTaskRewards: {},
  membershipList: {},
  playerActivity: {},
  levelChange: {},
  playerEntries: [],
  playerHistoryEntries: [],
  filters: {},
  activePlayerProfileId: null,
  activePlayerEntriesKey: null,
  activePlayerHistoryEntriesKey: null,
  activePlayerTransactionsKey: null,
  activePlayerReferralRewardsKey: null,
  activePlayerFirstTaskRewardsKey: null,
  activePlayerWalletTransactionsKey: null,
  activePlayerMembershipListKey: null,
  activePlayerActivityKey: null,
  activeLevelChangeKey: null,
  loading: false,
}

const getRequestKey = owner => {
  if (!owner) {
    return null
  }

  const sortedOptions = Object.keys(owner.options || {})
    .sort()
    .reduce((acc, key) => {
      acc[key] = owner.options[key]
      return acc
    }, {})

  return `${owner.userId || owner.accountId || owner.id || ""}:${JSON.stringify(
    sortedOptions
  )}`
}

const isStaleResponse = (activeKey, owner) =>
  owner && getRequestKey(owner) !== activeKey

const players = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLAYER_ENTRIES:
      state = {
        ...state,
        activePlayerEntriesKey: getRequestKey({
          userId: action.id,
          options: action.playerEntriesOptions,
        }),
        loading: true,
      }
      break
    case GET_PLAYER_ENTRIES_SUCCESS:
      if (isStaleResponse(state.activePlayerEntriesKey, action.owner)) {
        break
      }
      state = {
        ...state,
        loading: false,
        playerEntries: action.data,
      }
      break
    case GET_PLAYER_HISTORY_ENTRIES:
      state = {
        ...state,
        activePlayerHistoryEntriesKey: getRequestKey({
          userId: action.id,
          options: action.playerHistoryEntriesOptions,
        }),
        loading: true,
      }
      break
    case GET_PLAYER_HISTORY_ENTRIES_SUCCESS:
      if (isStaleResponse(state.activePlayerHistoryEntriesKey, action.owner)) {
        break
      }
      state = {
        ...state,
        loading: false,
        playerHistoryEntries: action.data,
      }
      break
    case GET_PLAYERS_LIST:
      state = {
        ...state,
        playersList: {
          ...state.playersList,
          results: [],
          totalResults: 0,
        },
        loading: true,
      }
      break
    case GET_PLAYER_TRANSACTIONS:
      state = {
        ...state,
        activePlayerTransactionsKey: getRequestKey({
          userId: action.id,
          options: action.transactionsOptions,
        }),
      }
      break
    case GET_PLAYER_TRANSACTIONS_SUCCESS:
      if (isStaleResponse(state.activePlayerTransactionsKey, action.owner)) {
        break
      }
      state = {
        ...state,
        loading: false,
        playerTransactions: action.payload,
      }
      break
    case GET_PLAYER_REFERRAL_REWARDS:
      state = {
        ...state,
        activePlayerReferralRewardsKey: getRequestKey({
          userId: action.id,
          options: {
            type: "referralReward",
            limit: 1000,
          },
        }),
      }
      break
    case GET_PLAYER_REFERRAL_REWARDS_SUCCESS:
      if (isStaleResponse(state.activePlayerReferralRewardsKey, action.owner)) {
        break
      }
      state = {
        ...state,
        loading: false,
        referralRewards: action.payload,
      }
      break
    case GET_PLAYER_FIRST_TASK_REWARDS:
      state = {
        ...state,
        activePlayerFirstTaskRewardsKey: getRequestKey({
          userId: action.id,
          options: {
            type: "firstTaskCompletion",
            limit: 1000,
          },
        }),
      }
      break
    case GET_PLAYER_FIRST_TASK_REWARDS_SUCCESS:
      if (
        isStaleResponse(state.activePlayerFirstTaskRewardsKey, action.owner)
      ) {
        break
      }
      state = {
        ...state,
        loading: false,
        firstTaskRewards: action.payload,
      }
      break
    case GET_PLAYER_WALLET_TRANSACTIONS:
      state = {
        ...state,
        activePlayerWalletTransactionsKey: getRequestKey({
          userId: action.id,
          options: action.options,
        }),
      }
      break
    case GET_PLAYER_WALLET_TRANSACTIONS_SUCCESS:
      if (
        isStaleResponse(state.activePlayerWalletTransactionsKey, action.owner)
      ) {
        break
      }
      state = {
        ...state,
        loading: false,
        playerWalletTransactions: action.payload,
      }
      break
    case GET_PLAYER_MEMBERSHIP_LIST:
      state = {
        ...state,
        activePlayerMembershipListKey: getRequestKey({
          userId: action.id,
          options: action.membershipOptions,
        }),
      }
      break
    case GET_PLAYER_MEMBERSHIP_LIST_SUCCESS:
      if (isStaleResponse(state.activePlayerMembershipListKey, action.owner)) {
        break
      }
      state = {
        ...state,
        loading: false,
        membershipList: action.payload,
      }
      break
    case GET_PLAYER_ACTIVITY:
      state = {
        ...state,
        activePlayerActivityKey: getRequestKey({
          accountId: action.id,
          options: action.playerActivityOptions,
        }),
      }
      break
    case GET_PLAYER_ACTIVITY_SUCCESS:
      if (isStaleResponse(state.activePlayerActivityKey, action.owner)) {
        break
      }
      state = {
        ...state,
        loading: false,
        playerActivity: action.payload,
      }
      break
    case GET_LEVEL_CHANGE:
      state = {
        ...state,
        activeLevelChangeKey: getRequestKey({
          accountId: action.id,
          options: action.levelChangeOptions,
        }),
      }
      break
    case GET_LEVEL_CHANGE_SUCCESS:
      if (isStaleResponse(state.activeLevelChangeKey, action.owner)) {
        break
      }
      state = {
        ...state,
        loading: false,
        levelChange: action.payload,
      }
      break
    case GET_PLAYERS_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        playersList: action.payload,
      }
      break
    case GET_PLAYERS:
      state = {
        ...state,
        loading: true,
        searchLoading: true,
        searchError: null,
      }
      break
    case GET_PLAYERS_SUCCESS:
      state = {
        ...state,
        loading: false,
        players: action.payload,
        searchLoading: false,
        searchError: null,
      }
      break
    case GET_PLAYERS_FAILURE:
      state = { ...state, loading: false, searchLoading: false, searchError: action.payload }
      break
    // The Location options load on their own, when their menu opens, so they never touch the list's loading state.
    // A read drops the options of the previous filter set, and a failed one leaves none.
    case GET_PLAYERS_LOCATIONS:
      state = {
        ...state,
        playersLocationsLoading: true,
        playersLocations: [],
      }
      break
    case GET_PLAYERS_LOCATIONS_SUCCESS:
      state = {
        ...state,
        playersLocationsLoading: false,
        playersLocations: action.payload,
      }
      break
    case GET_PLAYERS_LOCATIONS_FAILURE:
      state = {
        ...state,
        playersLocationsLoading: false,
        playersLocations: [],
      }
      break
    case CHANGE_PLAYERS_FILTERS:
      state = {
        ...state,
        loading: false,
        filters: action.payload,
      }
      break
    case GET_PLAYER_INFO:
      state = {
        ...state,
        activePlayerProfileId: action.id,
        profileError: null,
        profileLoading: true,
        loading: true,
      }
      break
    case GET_PLAYER_INFO_SUCCESS:
      if (
        action.profileId &&
        action.profileId !== state.activePlayerProfileId
      ) {
        break
      }
      state = {
        ...state,
        loading: false,
        playerInfo: action.payload,
        profileError: null,
        profileLoading: false,
      }
      break
    case GET_PLAYER_INFO_FAILURE:
      if (action.profileId !== state.activePlayerProfileId) break
      state = {
        ...state,
        playerInfo: {},
        profileError: action.payload,
        profileLoading: false,
        loading: false,
      }
      break
    case RESET_PLAYER_PROFILE_DATA:
      state = {
        ...state,
        playerInfo: {},
        profileError: null,
        profileLoading: false,
        playerTransactions: {},
        playerWalletTransactions: {},
        referralRewards: {},
        firstTaskRewards: {},
        membershipList: {},
        playerActivity: {},
        levelChange: {},
        playerEntries: [],
        playerHistoryEntries: [],
        activePlayerProfileId: null,
        activePlayerEntriesKey: null,
        activePlayerHistoryEntriesKey: null,
        activePlayerTransactionsKey: null,
        activePlayerReferralRewardsKey: null,
        activePlayerFirstTaskRewardsKey: null,
        activePlayerWalletTransactionsKey: null,
        activePlayerMembershipListKey: null,
        activePlayerActivityKey: null,
        activeLevelChangeKey: null,
        loading: false,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default players
